export const visit = (vm, at) => {
at({ "en-gb": { "conversations-message-history": { "status": { "closed": "This thread was closed on {{ dateString }}", "restore": "Restore this message", "publishing": { "UNPUBLISHED": "Sending... ", "PUBLISH_FAILED": "Not delivered. Click to retry." } } } } });
};